const MarkdownP = ({ ...props }) => {
  return <p className="mb-4 text-14" {...props} />;
};

export default MarkdownP;
